import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { UserInfoInterface } from '@core/models/authentication.model';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { Observable } from 'rxjs';
import { navbarData } from './model/sidenav-data';
import { NavbarData } from './model/sidenav.model';
import { SublevelMenuComponent } from './sublevel-menu.component';

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [CommonModule, RouterModule, SublevelMenuComponent],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  @Output() toggleSideNav = new EventEmitter<SideNavToggle>();
  collapsed = true;
  screenWidth = 0;
  navData = navbarData;
  multiple = false;
  userInfo$!: Observable<UserInfoInterface>;

  constructor(
    public router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.userInfo$ = this.authenticationService.userInfo$;
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.toggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  handleClick(item: NavbarData): void {
    if (!this.collapsed) {
      this.toggleCollapse();
    }
    if (!this.multiple) {
      for (const modelItem of this.navData) {
        if (item !== modelItem && modelItem.expanded) {
          modelItem.expanded = false;
        }
      }
    }
    item.expanded = !item.expanded;
  }

  getActiveClass(data: NavbarData): string {
    return this.router.url.includes(data.routeLink) ? 'active' : '';
  }

  shrinkItems(item: NavbarData): void {
    if (!this.multiple) {
      for (const modelItem of this.navData) {
        if (item !== modelItem && modelItem.expanded) {
          modelItem.expanded = false;
        }
      }
    }
  }
}
